// DS1.7.21
import React from 'react';
import c from 'classnames';
import CoreSymbol from '../CoreSymbol';
import { IconSize } from '../../Icons/IconWrap';
import s from './CoreUpgrade.scss';
const CoreUpgrade = ({ className, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        size: IconSize.SMALL
    }), children);
};
CoreUpgrade.displayName = 'CoreUpgrade';
export default CoreUpgrade;
